import api from './api'

class ReviewService {
  static addReview(data) {
    return api.call('post', `/product/review/add`, data).then(api.getData)
  }
}

export default ReviewService
